import React from 'react';

import './Logo.scss';

export interface ILogoProps {
	mini?: boolean;
	centered?: boolean;
}

export const Logo: React.FC<ILogoProps> = ({ mini, centered }) => {
	const logoClasses = [
		'logo',
		mini ? 'logo--mini' : '',
		centered ? 'logo--centered' : '',
	];

	return <div title="Asaph" className={logoClasses.join(' ')} />;
};

export default Logo;
